module.exports = __webpack_public_path__ + "static/media/tractor.a5b86648.png";